import {isAxiosError} from 'axios';

export function getUpdateEmailErrorMessage(error: unknown): string {
	if (isAxiosError<{errors?: string[]; message?: string; detail?: string}>(error)) {
		return (
			error.response?.data?.errors?.[0] ||
			error.response?.data?.message ||
			error.response?.data?.detail ||
			error.message
		);
	}

	return error instanceof Error ? error.message : 'Не удалось обновить e-mail';
}
